<template>
  <hm-content title="">
    <div class="flex-column">
      <div>
        <el-select
            class="mr10"
            size="small"
            filterable
            placeholder="请选择"
            v-model="searchCondition.group"
        >
          <el-option
              v-for="(item, i) in ipWhitelist"
              :key="i"
              :label="item.itemText"
              :value="item.itemValue"
          ></el-option>
        </el-select>
        <el-input
            clearable
            style="width:200px"
            v-model.trim="searchCondition.ip"
            placeholder="输入IP"
            size="small"
            class="ipt mr10"
        >
        </el-input>
        <el-button type="primary" size="small" @click="confirm">设 置</el-button>
      </div>
      <div class="mt20">
        服务地址:
        <el-select
            class="mr10"
            size="small"
            filterable
            placeholder="请选择"
            v-model="serverSearchCondition.serverUrl"
            style="width: 300px"
        >
          <el-option
              v-for="(item, i) in serverUrlList"
              :key="i"
              :label="item.itemText"
              :value="item.itemText"
          ></el-option>
        </el-select>
        <el-select
            class="mr10"
            size="small"
            filterable
            placeholder="请选择"
            v-model="serverSearchCondition.server"
        >
          <el-option
              v-for="(item, i) in serverList"
              :key="i"
              :label="item.itemText"
              :value="item.itemText"
          ></el-option>
        </el-select>
        /provider
        <el-select
            class="mr10"
            size="small"
            filterable
            placeholder="请选择"
            v-model="serverSearchCondition.pg"
        >
          <el-option
              v-for="(item, i) in pgList"
              :key="i"
              :label="item.itemText"
              :value="item.itemText"
          ></el-option>
        </el-select>
        <el-input
            clearable
            style="width:200px"
            v-model.trim="serverSearchCondition.interfaceUrl"
            placeholder="输入接口地址"
            size="small"
            class="ipt mr10"
        >
        </el-input>
        <el-button type="primary" size="small" @click="testUrl">测试连接</el-button>
      </div>
    </div>


  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      group: "",
      searchCondition: {
        group: "",
        ip: ""
      },
      serverSearchCondition: {
        serverUrl: "",
        server: "",
        pg: "",
        interfaceUrl: "",
      },
      ipWhitelist: [],
      serverUrlList:[{
        "itemText": "https://hexin.hemiao100.com"
      },{
        "itemText": "https://hx.hemiao100.com"
      },{
        "itemText": "https://hxa.hemiao100.com"
      }],
      serverList:[{
        "itemText": "/appg"
      },{
        "itemText": "/backend"
      }],
      pgList:[{
        "itemText": "/tenant"
      },{
        "itemText": "/order"
      },{
        "itemText": "/activity"
      },{
        "itemText": "/message"
      },{
        "itemText": "/guider"
      },{
        "itemText": "/thirderp"
      },{
        "itemText": "/goods"
      },{
        "itemText": "/member"
      },{
        "itemText": "/tag"
      },{
        "itemText": "/rest"
      },{
        "itemText": "/redpackage"
      },{
        "itemText": "/es"
      },{
        "itemText": "/promotion"
      },{
        "itemText": "/reabam"
      }]
    };
  },
  created() {},
  mounted() {
    this.queryAliyunIpWhitelist();
    let IP = returnCitySN['cip'] // ip
    console.log("IP", IP);
    this.searchCondition.ip = IP;
  },
  methods: {
    async confirm() {
      if (!this.searchCondition.group || !this.searchCondition.ip) {
        this.$message({
          message: "请输入IP",
          type: "warning"
        });
        return;
      }
      await this.$store.dispatch("setAliyunIpWhitelist", this.searchCondition);
      this.$message({
        message: "操作成功！",
        type: "success"
      });
    },
    async testUrl() {
      let url = this.serverSearchCondition.serverUrl
      if (this.serverSearchCondition.server) {
        url += this.serverSearchCondition.server;
      }
      url += "/provider";
      if (this.serverSearchCondition.pg) {
        url += this.serverSearchCondition.pg;
      }
      if (this.serverSearchCondition.interfaceUrl) {
        url += "/" + this.serverSearchCondition.interfaceUrl;
      }
      window.open(url)

    },
    async queryAliyunIpWhitelist() {
      const { result } = await this.$store.dispatch("queryAliyunIpWhitelist");
      this.ipWhitelist = result;
      this.searchCondition.group = result[0].itemValue;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
